import * as actions from './actions'
import mutations from './mutations'
export default {
    namespaced: true,
    state:{
        faqList: null,
    },
    actions,
    mutations
}